import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface StatCardProps {
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  description?: string;
}
export function StatCard({
  value,
  label,
  icon,
  trend,
  description
}: StatCardProps) {
  return <div className="relative bg-[#0a0a0a] border border-gray-800 p-6 flex flex-col h-full hover:border-[#FF0000]/50 transition-all duration-300 group" data-id="element-1148" data-mp="y9sbp5d7hevz">
      {/* Corner Brackets */}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-1149" data-mp="5mo3kritgkfz" />
      <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-1150" data-mp="anc2dzdae5kr" />
      <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-1151" data-mp="1m0xrxln2696t" />
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-1152" data-mp="1qxefadmfojiu" />

      <div className="flex items-start justify-between mb-4" data-id="element-1153" data-mp="3ny1xsxx9695b">
        <div className="p-2.5 bg-[#FF0000]/10 border border-[#FF0000] text-[#FF0000]" data-id="element-1154" data-mp="3nyk4kohjk5rh">
          {icon}
        </div>

        {trend && <div className={`flex items-center gap-1 text-xs font-mono px-2 py-1 border ${trend.isPositive ? 'bg-green-500/10 text-green-500 border-green-500/30' : 'bg-red-500/10 text-red-500 border-red-500/30'}`} data-id="element-1155" data-mp="3e04969bheac6">
            {trend.isPositive ? <ArrowUpRight size={12} data-id="element-1156" data-mp="347yh6zl8bswz" /> : <ArrowDownRight size={12} data-id="element-1157" data-mp="308zgxsag0kbv" />}
            {Math.abs(trend.value)}%
          </div>}
      </div>

      <div className="mt-auto" data-id="element-1158" data-mp="2v70d6hasjlee">
        <div className="text-3xl font-black text-white tracking-tight mb-2 font-mono" data-id="element-1159" data-mp="2q9qq38avjltq">
          {value}
        </div>
        <div className="text-xs font-mono text-gray-400 uppercase tracking-widest" data-id="element-1160" data-mp="2lanl1nuw9flr">
          {label}
        </div>
        {description && <div className="text-[10px] text-gray-600 mt-2 font-mono" data-id="element-1161" data-mp="2bpe8xkqall0x">
            {description}
          </div>}
      </div>
    </div>;
}